<dgx-breadcrumbs [breadcrumbs]="breadcrumbs"></dgx-breadcrumbs>
<dgx-content-insights
  [orgId]="pathway.organizationId"
  [pathwayId]="pathway.id"
  [isViewAll]="true"
  class="grid__col-sm-12 guts-m-t-1"
></dgx-content-insights>
